import { render } from "./stats-card.vue?vue&type=template&id=2fe08f1a&scoped=true&ts=true"
import script from "./stats-card.vue?vue&type=script&lang=ts"
export * from "./stats-card.vue?vue&type=script&lang=ts"

import "./stats-card.vue?vue&type=style&index=0&id=2fe08f1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe08f1a"]])

export default __exports__